import React, { useState } from 'react';
import { Alert, Button, Card, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../LoginForm/styles.css';

const ForgotPasswordForm = ({ onRequestCode, onConfirmReset, isLoading, alert, onAlertClose }) => {
    const [step, setStep] = useState('request');
    const [email, setEmail] = useState('');
    const [code, setCode] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');

    const handleRequestCode = async (e) => {
        e.preventDefault();
        if (!email) {
            setError('Email is required');
            return;
        }
        setError('');
        const success = await onRequestCode(email);
        if (success) setStep('confirm');
    };

    const handleConfirmReset = (e) => {
        e.preventDefault();
        if (!code || !newPassword || !confirmPassword) {
            setError('All fields are required');
            return;
        }
        if (newPassword !== confirmPassword) {
            setError('Passwords do not match');
            return;
        }
        setError('');
        onConfirmReset(email, code, newPassword);
    };

    return (
        <Card className="login-card shadow-sm">
            <Card.Header>
                <h5 className="app-name">FitOps</h5>
            </Card.Header>
            <Card.Body>
                {error && (
                    <Alert variant="danger" dismissible onClose={() => setError('')}>
                        {error}
                    </Alert>
                )}
                {alert && alert.show && (
                    <Alert variant={alert.variant} dismissible onClose={onAlertClose}>
                        {alert.message}
                    </Alert>
                )}

                {step === 'request' ? (
                    <Form onSubmit={handleRequestCode}>
                        <Form.Group className="mb-3" controlId="formEmail">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="you@example.com"
                                autoComplete="email"
                                required
                            />
                            <Form.Text className="text-muted">
                                We'll send a verification code to this address.
                            </Form.Text>
                        </Form.Group>
                        <Button type="submit" className="w-100 login-submit-btn" disabled={isLoading}>
                            {isLoading ? 'Sending…' : 'Send Code'}
                        </Button>
                    </Form>
                ) : (
                    <Form onSubmit={handleConfirmReset}>
                        <Form.Group className="mb-3" controlId="formCode">
                            <Form.Label>Verification Code</Form.Label>
                            <Form.Control
                                type="text"
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                                placeholder="6-digit code"
                                autoComplete="one-time-code"
                                required
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formNewPassword">
                            <Form.Label>New Password</Form.Label>
                            <Form.Control
                                type="password"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                placeholder="••••••••"
                                autoComplete="new-password"
                                required
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formConfirmPassword">
                            <Form.Label>Confirm New Password</Form.Label>
                            <Form.Control
                                type="password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                placeholder="••••••••"
                                autoComplete="new-password"
                                required
                            />
                        </Form.Group>
                        <Button type="submit" className="w-100 login-submit-btn" disabled={isLoading}>
                            {isLoading ? 'Resetting…' : 'Reset Password'}
                        </Button>
                    </Form>
                )}
            </Card.Body>
            <Card.Footer>
                {step === 'confirm' && (
                    <>
                        <button
                            className="btn btn-link p-0"
                            style={{ fontSize: 'var(--font-size-sm)' }}
                            onClick={() => setStep('request')}
                            disabled={isLoading}
                        >
                            Resend code
                        </button>
                        <span className="divider">·</span>
                    </>
                )}
                <Link to="/login">Back to log in</Link>
            </Card.Footer>
        </Card>
    );
};

export default ForgotPasswordForm;
